/**
 * Legacy CartApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.cartApi`) keep resolving.
 *
 * The actual CartApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/cart/cart-api.service.ts
 */
angular.module("acme.common.service.cartApi", [
  "acme.common.factory.apiVersion",
]);
